// 서버 시간 동기화 유틸리티 (NTP-style offset)
// 모든 클라이언트(Electron/Android)가 서버 시간 기준으로 동일한 타이머를 표시하도록
// 클라이언트 로컬 시계와 서버 시계의 차이(offset)를 계산하여 보정한다.

let _offset = 0

/**
 * 서버 시간 기준 오프셋을 계산하여 저장한다.
 * NTP simple algorithm: offset = serverTime - (clientSendTime + RTT/2)
 * @param clientSendTime - 요청 전 Date.now()
 * @param serverTimeIso - 서버가 응답한 ISO 8601 시각 문자열
 * @param clientReceiveTime - 응답 수신 후 Date.now()
 */
export const syncServerTime = (clientSendTime: number, serverTimeIso: string, clientReceiveTime: number): void => {
  const serverMs = new Date(serverTimeIso).getTime()
  if (Number.isNaN(serverMs)) return

  const rtt = clientReceiveTime - clientSendTime
  const estimatedClientTimeAtServer = clientSendTime + rtt / 2
  _offset = serverMs - estimatedClientTimeAtServer
}

/** 현재 서버 시간 오프셋(ms) 반환 */
export const getServerTimeOffset = (): number => _offset

/** 서버 시간 보정된 현재 시각(ms) 반환. Date.now() 대신 사용한다. */
export const getSyncedNow = (): number => Date.now() + _offset
